import { I18n } from 'common/i18n';
import { scgcEnabled } from 'common/domain/helpers';
import { currentUserHasRight } from 'common/current_user';
import { DomainRights } from 'common/tests/dataMimics/User/types';
import { SelectDropdownConfig } from './filter-config';
import { Filters } from 'common/components/AssetBrowser/lib/helpers/enabled_filters';
import { FilterScope, getAllOption, getScope } from './translations';
import { FilterType, SelectOption } from '../config/types';
import * as filters from 'common/components/AssetBrowser/actions/filters';

const scope = getScope(FilterScope.Visibility);

const getVisibilityOptions = (): SelectOption[] => {
  const visibilityOptions = [
    getAllOption(scope),
    { label: I18n.t('options.public', { scope }), value: 'open' },
  ];

  if (scgcEnabled() && currentUserHasRight(DomainRights.can_view_internal_data)) {
    visibilityOptions.push({ label: I18n.t('options.internal', { scope }), value: 'site' });
  }

  visibilityOptions.push({ label: I18n.t('options.private', { scope }), value: 'internal' });

  return visibilityOptions;
};

export const visibilityConfigs: SelectDropdownConfig = {
  filterName: Filters.Visibility,
  label: scgcEnabled()
    ? I18n.t('alternate_label', { scope: getScope(FilterScope.Visibility) })
    : I18n.t('label', { scope: getScope(FilterScope.Visibility) }),
  getOptions: getVisibilityOptions,
  dispatchAction: filters.changeVisibility,
  filterType: FilterType.SelectDropdown,
};
